// Shared delete-dialog / warning-dialog state + helpers duplicated between
// BlacklistChatUserManagement and UserChatManagement. Byte-identical except
// the '!item' guard in openDeleteDialog, which existed only in the Blacklist
// copy and is strictly safer — kept for both (deliberate micro-hardening).
export default {
  data() {
    return {
      showDeleteDialog: false,
      item: null,
      deleting: false,
      showWarningDialog: false,
      warningTitle: "",
      warningMessage: "",
      showButton: true,
    };
  },
  methods: {
    openDeleteDialog(item) {
      if (!item) return;
      this.showDeleteDialog = true;
      this.item = item;
    },
    closeDeleteDialog() {
      if (this.deleting) return;
      this.showDeleteDialog = false;
      this.item = null;
    },
    openWarningDialog(title, message, show = true, sec = 3000) {
      this.warningTitle = title;
      this.warningMessage = message;
      this.showWarningDialog = true;
      this.showButton = show;
      if(!show){
        setTimeout(() => {
          this.closeWarningDialog();
        }, sec);
      }
    },
    closeWarningDialog() {
      this.showWarningDialog = false;
      this.warningTitle = "";
      this.warningMessage = "";
    },
  },
};
